// Design System Constants
// Use these throughout your app for consistency

export const COLORS = {
  primary: '#e88421', // 0b5d1e green
  // primaryLight: '#095d1d',
  // primaryDark: '#145024',
  primaryLight: '#f0952e',
  primaryDark: '#d97510',
  secondary: '#15304a',
  secondaryLight: '#0d1f2d',
  accent: '#e88421',
  white: '#ffffff',
  bgLight: '#f8f9fa',
  bgGray: '#efefef',
  textPrimary: '#333333',
  textSecondary: '#666666',
  textLight: '#777777',
  border: '#e0e0e0',
};

// Common component styles as Tailwind classes
export const BUTTON_STYLES = {
  primary: 'bg-primary hover:bg-primary-dark text-white font-semibold py-3 px-6 rounded shadow-button transition-all duration-300 hover:shadow-heavy hover:-translate-y-0.5',
  secondary: 'bg-white hover:bg-background-light text-primary border border-primary font-semibold py-3 px-6 rounded shadow-md transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5',
  large: 'text-lg py-4 px-8',
  small: 'text-sm py-2 px-4',
};

export const CARD_STYLES = {
  base: 'bg-white rounded border border-border shadow-light hover:shadow-medium transition-all duration-300',
  elevated: 'bg-white rounded shadow-medium hover:shadow-heavy transition-all duration-300 hover:-translate-y-1',
  flat: 'bg-background-gray rounded p-5',
};

export const TEXT_STYLES = {
  heading1: 'text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary leading-tight',
  heading2: 'text-2xl md:text-3xl lg:text-4xl font-bold text-primary leading-tight',
  heading3: 'text-xl md:text-2xl lg:text-3xl font-bold text-text-primary',
  heading4: 'text-lg md:text-xl font-semibold text-text-primary',
  body: 'text-base text-text-primary leading-relaxed',
  bodySmall: 'text-sm text-text-secondary leading-relaxed',
  label: 'text-sm font-semibold text-text-primary',
};

export const CONTAINER_STYLES = {
  page: 'min-h-screen bg-background-light',
  section: 'py-12 md:py-16 lg:py-20 px-4 sm:px-6 lg:px-8',
  container: 'max-w-7xl mx-auto',
  narrow: 'max-w-4xl mx-auto',
};

export const GRID_STYLES = {
  responsive: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6',
  twoCol: 'grid grid-cols-1 md:grid-cols-2 gap-8',
  features: 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6',
};

export const INPUT_STYLES = {
  base: 'w-full px-4 py-3 border-2 border-border rounded focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 transition-all text-base',
  wrapper: 'flex w-full border-2 border-border rounded overflow-hidden bg-white transition-all duration-300 focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20',
};

// Responsive spacing utilities
export const SPACING = {
  sectionY: 'py-12 md:py-16 lg:py-20',
  sectionX: 'px-4 sm:px-6 lg:px-8',
  cardPadding: 'p-6 md:p-8 lg:p-10',
  gap: 'gap-6 md:gap-8 lg:gap-10',
};

// Animation classes
export const ANIMATIONS = {
  fadeIn: 'animate-fade-in',
  slideUp: 'animate-slide-up',
  hover: 'transition-all duration-300 hover:scale-105',
};

export const FLASHOFFER = {
  tagline: 'Extra 35% Off on 1st year'
}